import type { QueryParams } from '~/types/api'
import type { Job, JobPagedResult } from '~/types/api'

export function createJobsRepository() {
  const { $api } = useNuxtApp()
  const { get } = baseRepository($api)

  const DOMAIN = 'jobs'
  const LANG = 'careers'

  async function getAll(params?: QueryParams) {
    return get<JobPagedResult>([DOMAIN], { params })
  }

  async function getByNid(nid: number) {
    return get<Job>([DOMAIN, nid.toString()]) // TODO: This was in "langPath", but I don't think it's needed anymore ['base', LANG]
  }

  return {
    getAll,
    getByNid,
  }
}
